export default __webpack_public_path__ + "static/media/hj 1.7d11033e.png";